import { formatActionText } from 'pages/WellGuardian/WIR/utils';
import {
  ENGINEERING_WORK_ACTION_LABEL,
  WIRCreateJourneyStepsKeys,
  WIREngineeringWorkSectionKey,
  WIREngineeringWorkSections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { CountryData, WIR, WIRActionStatus } from 'types/wellGuardian';

const fixedDate = new Date('2023-03-13T00:00:59.349Z'); // *NOTE*: After the given fixed Date, the newly created WIR's wont have the subtask Intervention Strategy Defined in the Engineering Phase.

const getCGEngineeringWorkSections = (wir: WIR | null) => {
  return (
    (wir &&
      Object.keys(WIREngineeringWorkSections)
        .map(item => ({
          label: WIREngineeringWorkSections[item as WIREngineeringWorkSectionKey],
          value: item,
          phase: WIRCreateJourneyStepsKeys.CG_ENGINEERING_WORK,
        }))
        .filter(stepItem =>
          stepItem.label === WIREngineeringWorkSections.aroRlo ||
          stepItem.label === WIREngineeringWorkSections.reviewChecklistActions ||
          stepItem.label === WIREngineeringWorkSections.programDraft ||
          (wir.startDate && // *NOTE*: After the given fixed Date, the newly created WIR's wont have the subtask Intervention Strategy Defined in the Engineering Phase.
            new Date(wir?.startDate).getTime() < fixedDate.getTime() &&
            stepItem.label === WIREngineeringWorkSections.interventionStrategyDefined)
            ? true
            : wir?.actions?.some(
                item =>
                  item.actionName ===
                    formatActionText(stepItem.label, ENGINEERING_WORK_ACTION_LABEL) &&
                  item.state !== WIRActionStatus.DELETED,
              ),
        )) ??
    []
  );
};

const getIREngineeringWorkSections = (wir: WIR | null) => {
  return (
    (wir &&
      Object.keys(WIREngineeringWorkSections)
        .map(item => ({
          label: WIREngineeringWorkSections[item as WIREngineeringWorkSectionKey],
          value: item,
          phase: WIRCreateJourneyStepsKeys.IRAQ_ENGINEERING_WORK,
        }))
        .filter(stepItem =>
          stepItem.label === WIREngineeringWorkSections.afeCreated ||
          stepItem.label === WIREngineeringWorkSections.equipmentIdentification ||
          // stepItem.label === WIREngineeringWorkSections.vendorEngagementSelection ||
          stepItem.label === WIREngineeringWorkSections.reviewChecklistActions ||
          stepItem.label === WIREngineeringWorkSections.technicalPosEstabilished ||
          stepItem.label === WIREngineeringWorkSections.technicalReviewRiskReward ||
          (wir.startDate && // *NOTE*: After the given fixed Date, the newly created WIR's wont have the subtask Intervention Strategy Defined in the Engineering Phase.
            new Date(wir?.startDate).getTime() < fixedDate.getTime() &&
            stepItem.label === WIREngineeringWorkSections.interventionStrategyDefined)
            ? true
            : wir?.actions?.some(
                item =>
                  item.actionName ===
                    formatActionText(stepItem.label, ENGINEERING_WORK_ACTION_LABEL) &&
                  item.state !== WIRActionStatus.DELETED,
              ),
        )) ??
    []
  );
};

const getAREngineeringWorkSections = (wir: WIR | null) => {
  return (
    (wir &&
      Object.keys(WIREngineeringWorkSections)
        .map(item => ({
          label: WIREngineeringWorkSections[item as WIREngineeringWorkSectionKey],
          value: item,
          phase: WIRCreateJourneyStepsKeys.ARGENTINA_ENGINEERING_WORK,
        }))
        .filter(stepItem =>
          stepItem.label === WIREngineeringWorkSections.afeCreated ||
          stepItem.label === WIREngineeringWorkSections.equipmentIdentification ||
          stepItem.label === WIREngineeringWorkSections.vendorEngagementSelection ||
          stepItem.label === WIREngineeringWorkSections.reviewChecklistActions ||
          stepItem.label === WIREngineeringWorkSections.technicalPosEstabilished ||
          stepItem.label === WIREngineeringWorkSections.technicalReviewRiskReward ||
          (wir.startDate &&
            new Date(wir?.startDate).getTime() < fixedDate.getTime() &&
            stepItem.label === WIREngineeringWorkSections.interventionStrategyDefined)
            ? true
            : wir?.actions?.some(
                item =>
                  item.actionName ===
                    formatActionText(stepItem.label, ENGINEERING_WORK_ACTION_LABEL) &&
                  item.state !== WIRActionStatus.DELETED,
              ),
        )) ??
    []
  );
};

const getAGEngineeringWorkSections = (wir: WIR | null) => {
  return (
    (wir &&
      Object.keys(WIREngineeringWorkSections)
        .map(item => ({
          label: WIREngineeringWorkSections[item as WIREngineeringWorkSectionKey],
          value: item,
          phase: WIRCreateJourneyStepsKeys.AG_ENGINEERING_WORK,
        }))
        .filter(stepItem =>
          stepItem.label === WIREngineeringWorkSections.engineeringAnalysis ||
          stepItem.label === WIREngineeringWorkSections.reviewChecklistActions ||
          stepItem.label === WIREngineeringWorkSections.programDraft ||
          (wir.startDate && // *NOTE*: After the given fixed Date, the newly created WIR's wont have the subtask Intervention Strategy Defined in the Engineering Phase.
            new Date(wir?.startDate).getTime() < fixedDate.getTime() &&
            stepItem.label === WIREngineeringWorkSections.interventionStrategyDefined)
            ? true
            : wir?.actions?.some(
                item =>
                  item.actionName ===
                    formatActionText(stepItem.label, ENGINEERING_WORK_ACTION_LABEL) &&
                  item.state !== WIRActionStatus.DELETED,
              ),
        )) ??
    []
  );
};

export const getEngineeringWorkSections = (wir: WIR | null, country: string) => {
  if (country === CountryData.congo) {
    return getCGEngineeringWorkSections(wir);
  } else if (country === CountryData.iraq) {
    return getIREngineeringWorkSections(wir);
  } else if (country === CountryData.angola) {
    return getAGEngineeringWorkSections(wir);
  } else if (country === CountryData.argentina) {
    return getAREngineeringWorkSections(wir);
  } else {
    return (
      (wir &&
        Object.keys(WIREngineeringWorkSections)
          .map(item => ({
            label: WIREngineeringWorkSections[item as WIREngineeringWorkSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.ENGINEERING_WORK,
          }))
          .filter(stepItem =>
            stepItem.label === WIREngineeringWorkSections.afeCreated ||
            stepItem.label === WIREngineeringWorkSections.equipmentIdentification ||
            stepItem.label === WIREngineeringWorkSections.vendorEngagementSelection ||
            stepItem.label === WIREngineeringWorkSections.reviewChecklistActions ||
            stepItem.label === WIREngineeringWorkSections.technicalPosEstabilished ||
            stepItem.label === WIREngineeringWorkSections.technicalReviewRiskReward ||
            (wir.startDate && // *NOTE*: After the given fixed Date, the newly created WIR's wont have the subtask Intervention Strategy Defined in the Engineering Phase.
              new Date(wir?.startDate).getTime() < fixedDate.getTime() &&
              stepItem.label === WIREngineeringWorkSections.interventionStrategyDefined)
              ? true
              : wir?.actions?.some(
                  item =>
                    item.actionName ===
                      formatActionText(stepItem.label, ENGINEERING_WORK_ACTION_LABEL) &&
                    item.state !== WIRActionStatus.DELETED,
                ),
          )) ??
      []
    );
  }
};
